import React from "react";
import * as echarts from "echarts/lib/echarts";

let myChart = null;
class Charts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div
        id="ocharts"
        style={{ width: "100%", height: this.props.height }}
      ></div>
    );
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    myChart = !myChart
      ? echarts.init(document.getElementById("ocharts"))
      : myChart;
    const option = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      xAxis: {
        type: "value",
        boundaryGap: [0, 0.01],
      },
      yAxis: {
        type: "category",
        data: ["1月", "2月", "3月", "4月", "5月"],
      },
      series: [
        {
          name: "生化池",
          type: "bar",
          data: [150, 100, 210, 140, 160, 100],
        },
        {
          name: "水解酸化池",
          type: "bar",
          data: [160, 200, 300, 85, 90, 100],
        },
        {
          name: "MBR膜池",
          type: "bar",
          data: [130, 100, 230, 100, 130],
        },
        {
          name: "粗格栅",
          type: "bar",
          data: [150, 100, 200, 140, 140, 100],
        },
        {
          name: "细格栅",
          type: "bar",
          data: [147, 98, 135, 210, 160, 100],
        },
        {
          name: "紫外消毒",
          type: "bar",
          data: [300, 100, 200, 160, 140, 120],
        },
      ],
    };
    myChart.setOption(option);
    window.addEventListener("resize", this.resizeFn);
  }

  resizeFn() {
    myChart.resize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeFn);
    myChart = null;
  }
}

export default Charts;
